import { Navigate, useLocation } from 'react-router-dom';

type VendorPrivateRouteProps = {
    component: React.ComponentType;
};

const VendorPrivateRoute = ({
    component: RouteComponent,
}: VendorPrivateRouteProps) => {
    const location = useLocation();

    const vendorToken = localStorage.getItem('vendorAccessToken');

    if (!vendorToken) {
        return (
            <Navigate
                to="/account/vendor-login"
                state={{ from: location }}
                replace
            />
        );
    }

    return <RouteComponent />;
};

export default VendorPrivateRoute;